import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './app/App'
import './shared/ui/tokens.css'
import './shared/ui/terminal.css'
import './shared/ui/mobile.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
